import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const backfillRecognizeMercanaVips = unaryRpc({
  name: "backfillRecognizeMercanaVips",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    started: z.boolean(),
    workflowId: z.string().nullable(),
    message: z.string().optional(),
  }),
});

export const RecognizeMercanaVipBackfillProgress = z.object({
  processed: z.number(),
  updated: z.number(),
  skipped: z.number(),
});

export const getRecognizeMercanaVipBackfillStatus = unaryRpc({
  name: "getRecognizeMercanaVipBackfillStatus",
  input: z.object({ teamId: zExt.objectId() }),
  output: z
    .object({
      status: z.string(),
      progress: RecognizeMercanaVipBackfillProgress.nullable(),
    })
    .nullable(),
});
